import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { ElevatedBox, ElevatedButton } from 'components/layout'
import { FileThumb } from 'components/misc'
import styles from './file-card.styl'

export default class FileCard extends Component {
  static propTypes = {
    file: PropTypes.object.isRequired,
    src: PropTypes.string,
    awardId: PropTypes.number,
    onDeleteClick: PropTypes.func
  }

  state = {
    downloadedFile: '',
    loading: false
  }

  render() {
    const { file, src, awardId } = this.props
    const createdAt = get(file, 'createdAt')

    return (
      <ElevatedBox>
        <div className={styles.card}>
          <div className={styles.media}>
            <FileThumb fileUrl={src} />
          </div>
          <div className={styles.content}>
            {createdAt && (
              <small className={styles.date}>
                <FormattedDate value={createdAt} />
              </small>
            )}
            <h2 className={styles.title}>{file.title}</h2>
            <p className={styles.description}>{file.description}</p>
            {file.canBeDeleted &&
              this.props.onDeleteClick && (
                <div className={styles.footer}>
                  <ElevatedButton
                    flat
                    uppercase
                    negative
                    intlKey="button.delete"
                    onClick={() => this.props.onDeleteClick(awardId, file.id)}
                  >
                    Delete
                  </ElevatedButton>
                </div>
              )}
          </div>
        </div>
      </ElevatedBox>
    )
  }
}
